import React, { useState } from "react";
import "./clientProfile.css"; // Custom CSS for styling
import SearchHeader from "../searchResults/searchHeader";
import { useSelector, useDispatch } from "react-redux";
import { resetClientInfo } from "../../redux/clientSlice";
import { resetClientData } from "../../redux/clientDataSlice";
import { supabase } from "../../supabaseClient";
import { persistor } from "../../redux/store";
import { useNavigate } from "react-router-dom";

function ClientProfile() {
  // State to track the selected menu item
  const [selectedTab, setSelectedTab] = useState("personalInfo");
  const client = useSelector((state) => state.clientData.clientData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      dispatch(resetClientInfo());
      dispatch(resetClientData());
      await persistor.purge();

      navigate("/"); // Redirect to home page after logout
    } catch (error) {
      console.error("Error logging out:", error.message);
      alert("Failed to log out. Please try again.");
    }
  };

  // Function to render content based on the selected tab
  const renderContent = () => {
    switch (selectedTab) {
      case "personalInfo":
        return (
          <div className="content-profile">
            <h2>Personal Information</h2>
            <div className="info-item-profile">
              <div>Full Legal Name</div>
              <div>
                {client.name} <button className="edit-btn">Edit</button>
              </div>
            </div>
            <div className="info-item-profile">
              <div>Gender</div>
              <div>
                {client?.gender || "-"}{" "}
                <button className="edit-btn">Edit</button>
              </div>
            </div>
            <div className="info-item-profile">
              <div>Address</div>
              <div>
                {client?.city || "- "}, {client?.state || "-"},{" "}
                {client?.zip_code || "-"}{" "}
                <button className="edit-btn">Edit</button>
              </div>
            </div>
            <div className="info-item-profile">
              <div>Date of Birth</div>
              <div>
                {client?.dob || "-"} <button className="edit-btn">Edit</button>
              </div>
            </div>
            <div className="info-item-profile">
              <div>Email Address</div>
              <div>
                {client?.email || "-"}{" "}
                <button className="edit-btn">Edit</button>
              </div>
            </div>
            <div className="info-item-profile">
              <div>Phone Number</div>
              <div>
                {client?.phone || "-"}{" "}
                <button className="edit-btn">Edit</button>
              </div>
            </div>
          </div>
        );
      case "paymentMethod":
        return (
          <div className="content">
            <h2>Payment Method</h2>
            <p>Manage your payment methods here.</p>
          </div>
        );
      case "notifications":
        return (
          <div className="content">
            <h2>Notifications</h2>
            <p>Configure your notification settings.</p>
          </div>
        );
      case "securitySettings":
        return (
          <div className="content">
            <h2>Security Settings</h2>
            <p>Configure your account security settings.</p>
          </div>
        );
      case "languageRegion":
        return (
          <div className="content">
            <h2>Language & Region</h2>
            <p>Configure your language and region preferences.</p>
          </div>
        );
      case "helpSupport":
        return (
          <div className="content">
            <h2>Help & Support</h2>
            <p>Access help articles and contact support.</p>
          </div>
        );
      default:
        return <div className="content">Select an option from the menu.</div>;
    }
  };

  return (
    <div>
      <SearchHeader searchBar={false} headerColor="search-header-gray" />
      <div className="container-profile">
        <div className="menu">
          <button
            className="menu-item"
            onClick={() => setSelectedTab("personalInfo")}
          >
            Personal Information
          </button>
          <button
            className="menu-item"
            onClick={() => setSelectedTab("paymentMethod")}
          >
            Payment Method
          </button>
          <button
            className="menu-item"
            onClick={() => setSelectedTab("notifications")}
          >
            Notifications
          </button>
          <button
            className="menu-item"
            onClick={() => setSelectedTab("securitySettings")}
          >
            Security Settings
          </button>
          <button
            className="menu-item"
            onClick={() => setSelectedTab("languageRegion")}
          >
            Language & Region
          </button>
          <button
            className="menu-item"
            onClick={() => setSelectedTab("helpSupport")}
          >
            Help & Support
          </button>
          <button className="menu-item" onClick={handleLogout}>
            Log out
          </button>
        </div>

        <div className="content-area">{renderContent()}</div>
      </div>
    </div>
  );
}

export default ClientProfile;
